module.exports = __webpack_public_path__ + "assets/img/questionnaire.30316aa2.svg";